import React from "react";
import ReactExport from "react-export-excel";
import { Button, SvgIcon } from "@material-ui/core";
import { useStyles } from "../../adminStyles";

export default function ExportToExcelButton(props) {
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const { rows } = props;
    const { btnMobile } = useStyles();

    return (
        <ExcelFile
            element={
                <Button className={btnMobile} variant="contained">
                    <SvgIcon>
                        <path d="M 12 3 L 2 5 L 2 19 L 12 21 L 12 3 z M 14 5 L 14 7 L 16 7 L 16 9 L 14 9 L 14 11 L 16 11 L 16 13 L 14 13 L 14 15 L 16 15 L 16 17 L 14 17 L 14 19 L 21 19 C 21.552 19 22 18.552 22 18 L 22 6 C 22 5.448 21.552 5 21 5 L 14 5 z M 18 7 L 20 7 L 20 9 L 18 9 L 18 7 z M 4.1757812 8.296875 L 5.953125 8.296875 L 6.8769531 10.511719 C 6.9519531 10.692719 7.0084063 10.902625 7.0664062 11.140625 L 7.0917969 11.140625 C 7.1247969 10.997625 7.1919688 10.779141 7.2929688 10.494141 L 8.3222656 8.296875 L 9.9433594 8.296875 L 8.0078125 11.966797 L 10 15.703125 L 8.2714844 15.703125 L 7.1582031 13.289062 C 7.1162031 13.204062 7.0663906 13.032922 7.0253906 12.794922 L 7.0097656 12.794922 C 6.9847656 12.908922 6.934375 13.079594 6.859375 13.308594 L 5.7363281 15.703125 L 4 15.703125 L 6.0605469 11.996094 L 4.1757812 8.296875 z M 18 11 L 20 11 L 20 13 L 18 13 L 18 11 z M 18 15 L 20 15 L 20 17 L 18 17 L 18 15 z" />
                    </SvgIcon>
                </Button>
            }
        >
            <ExcelSheet data={rows} name="Projects">
                <ExcelColumn
                    label="Project Name"
                    value="projectName"
                    width={360}
                />
                <ExcelColumn label="Client" value="client" />
                <ExcelColumn label="Start Date" value="startDate" />
                <ExcelColumn label="End Date" value="endDate" />
            </ExcelSheet>
        </ExcelFile>
    );
}
